import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import CustomAxios from '../../../../utility/customAxios';
import { queryClient } from '../../queryClient';
import { queryKeys } from '../../queryKeys';

export const postRefreshOutlookAuth = async () => {
  const response = await CustomAxios.post(`integrations/outlook/refresh`);
  const { data } = response;
  return data;
};

export function useRefreshOutlookAuth() {
  const navigate = useNavigate();
  return useMutation({
    mutationFn: postRefreshOutlookAuth,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.organizationIntegrations],
      });
    },
    onError: (err: unknown) => {
      if (err instanceof Error) {
        if (err.message === 'OUTLOOK_AUTH_MISSING' || err.message === 'OUTLOOK_AUTH_TOKEN_EXPIRED') {
          navigate('/oauth2redirect-outlook');
        }
      }
    },
  });
}
